<template>
  <component
    v-for="block of content"
    :key="block._key"
    :is="getComponent(block._type)"
    v-bind="block"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StoryIntro from '@/components/StoryIntro.vue';
import StorySplit from '@/components/StorySplit.vue';
import StoryTwoUp from '@/components/StoryTwoUp.vue';

interface ComponentTypes {
  [key: string]: string;
}

export default defineComponent({
  components: {
    StoryIntro,
    StorySplit,
    StoryTwoUp,
  },
  props: {
    content: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const types: ComponentTypes = {
      introText: 'StoryIntro',
      columns: 'StorySplit',
      images: 'StoryTwoUp',
    };
    const getComponent = (key: keyof ComponentTypes) => {
      return types[key] || 'div';
    };
    return { getComponent };
  },
});
</script>
